import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import PageHeader from '../components/PageHeader';
import { AISidebar, AIRecommendationPanel } from '../components/ai';
import { exportToCSV, formatDateForCSV } from '../utils/exportCSV';
import { Plus, Search, Filter, MoreVertical, Edit, Copy, Pause, Play, Gift, Download, Calendar, MessageCircle, SkipBack, ArrowUpDown, Gem } from 'lucide-react';
// Mock rewards data - Prodotti La Saponaria with working placeholder images
const mockRewards = [{
  id: 1,
  code: 'SIERO-HA-001',
  name: 'Siero Acido Ialuronico Multi-Peso',
  type: 'Prodotto Viso',
  status: 'Attivo',
  cost: 50,
  image: 'https://images.unsplash.com/photo-1556228578-8c89e6adf883?w=200&h=200&fit=crop',
  availability: {
    current: 45,
    total: 100
  },
  redemptionsPeriod: 28,
  redemptionsTotal: 234,
  lastRedemption: '2 ore fa',
  location: 'Milano Centro',
  startDate: '2026-03-01',
  endDate: '2026-12-31',
  aiHint: null
}, {
  id: 2,
  code: 'SOLIDI-KIT-002',
  name: 'Kit Cosmetici Solidi Zero Waste',
  type: 'Cosmetici Solidi',
  status: 'Attivo',
  cost: 50,
  image: 'https://images.unsplash.com/photo-1608248543803-ba4f8c70ae0b?w=200&h=200&fit=crop',
  availability: {
    current: 12,
    total: 50
  },
  redemptionsPeriod: 22,
  redemptionsTotal: 187,
  lastRedemption: '5 ore fa',
  location: 'Roma Cola di Rienzo',
  startDate: '2026-03-15',
  endDate: '2026-08-30',
  aiHint: {
    text: 'Disponibilità bassa: aumenta stock del 40%',
    explanation: 'Basato su 187 riscatti totali e trend crescente (+25%), questo premio sta per esaurirsi. I cosmetici solidi zero-waste sono molto richiesti.'
  }
}, {
  id: 3,
  code: 'CREMA-VISO-003',
  name: 'Crema Viso Deep Care Anti-Age',
  type: 'Prodotto Viso',
  status: 'Inattivo',
  cost: 50,
  image: 'https://images.unsplash.com/photo-1556228720-195a672e8a03?w=200&h=200&fit=crop',
  availability: {
    current: 28,
    total: 80
  },
  redemptionsPeriod: 18,
  redemptionsTotal: 156,
  lastRedemption: '1 giorno fa',
  location: 'Bologna',
  startDate: '2026-04-01',
  endDate: null,
  aiHint: null
}, {
  id: 4,
  code: 'HENNE-004',
  name: 'Set Hennetica Tinte Vegetali',
  type: 'Prodotto Capelli',
  status: 'Attivo',
  cost: 60,
  image: 'https://images.unsplash.com/photo-1522338242992-e1a54906a8da?w=200&h=200&fit=crop',
  availability: {
    current: 23,
    total: 60
  },
  redemptionsPeriod: 15,
  redemptionsTotal: 142,
  lastRedemption: '3 ore fa',
  location: 'Milano Solari',
  startDate: null,
  endDate: '2026-12-31',
  aiHint: {
    text: 'Prova ad abbassare il costo di 10 punti per aumentare i riscatti',
    explanation: 'I premi nella fascia 45-55 punti hanno un tasso di conversione 18% più alto. Questo premio ha performance sotto la media per la sua categoria.'
  }
}, {
  id: 5,
  code: 'WORK-005',
  name: 'Workshop Cosmetici Fai-da-Te',
  type: 'Esperienza',
  status: 'Programmato',
  cost: 100,
  image: 'https://images.unsplash.com/photo-1556228453-efd6c1ff04f6?w=200&h=200&fit=crop',
  availability: {
    current: 15,
    total: 15
  },
  redemptionsPeriod: 0,
  redemptionsTotal: 0,
  lastRedemption: 'Mai',
  location: 'Pesaro (Sede)',
  startDate: '2026-05-01',
  endDate: '2026-08-30',
  aiHint: null
}, {
  id: 6,
  code: 'VOUCHER-20',
  name: 'Buono Sconto 20€ su Acquisto',
  type: 'Buono Sconto',
  status: 'Scaduto',
  cost: 40,
  image: 'https://images.unsplash.com/photo-1607083206968-13611e3d76db?w=200&h=200&fit=crop',
  availability: {
    current: 0,
    total: 0,
    unlimited: true
  },
  redemptionsPeriod: 45,
  redemptionsTotal: 312,
  lastRedemption: '1 ora fa',
  location: 'Tutte le Sedi',
  startDate: null,
  endDate: null,
  aiHint: null
}, {
  id: 7,
  code: 'CORPO-AHA-007',
  name: 'Crema Corpo AHA Levigante',
  type: 'Prodotto Corpo',
  status: 'Attivo',
  cost: 45,
  image: 'https://images.unsplash.com/photo-1556228578-0d85b1a4d571?w=200&h=200&fit=crop',
  availability: {
    current: 34,
    total: 70
  },
  redemptionsPeriod: 12,
  redemptionsTotal: 98,
  lastRedemption: '6 ore fa',
  location: 'Firenze',
  startDate: '2026-03-10',
  endDate: '2026-12-31',
  aiHint: null
}, {
  id: 8,
  code: 'BOX-BIO-008',
  name: 'Box Scoperta Prodotti Bio',
  type: 'Kit Prodotti',
  status: 'Inattivo',
  cost: 70,
  image: 'https://images.unsplash.com/photo-1596755389378-c31d21fd1273?w=200&h=200&fit=crop',
  availability: {
    current: 8,
    total: 30
  },
  redemptionsPeriod: 0,
  redemptionsTotal: 67,
  lastRedemption: '3 giorni fa',
  location: 'Torino',
  startDate: '2026-03-01',
  endDate: '2026-05-31',
  aiHint: null
}];
const Rewards = () => {
  const navigate = useNavigate();
  const [rewards, setRewards] = useState(mockRewards);
  const [filteredRewards, setFilteredRewards] = useState(mockRewards);
  const [statusFilter, setStatusFilter] = useState('Tutti');
  const [searchTerm, setSearchTerm] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [openMenuId, setOpenMenuId] = useState<number | null>(null);
  const [isAISidebarOpen, setIsAISidebarOpen] = useState(false);
  const [hoveredAITip, setHoveredAITip] = useState<number | null>(null);
  const [sortConfig, setSortConfig] = useState<{
    key: string | null;
    direction: 'asc' | 'desc' | null;
  }>({
    key: null,
    direction: null
  });
  const [toast, setToast] = useState<{
    message: string;
    show: boolean;
  }>({
    message: '',
    show: false
  });
  const tooltipRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    let result = [...mockRewards];
    if (statusFilter !== 'Tutti') {
      result = result.filter(reward => reward.status === statusFilter);
    }
    if (searchTerm) {
      result = result.filter(reward => reward.name.toLowerCase().includes(searchTerm.toLowerCase()));
    }
    // Date filtering
    if (dateFrom) {
      result = result.filter(reward => {
        if (!reward.startDate) return true;
        return new Date(reward.startDate) >= new Date(dateFrom);
      });
    }
    if (dateTo) {
      result = result.filter(reward => {
        if (!reward.endDate) return true;
        return new Date(reward.endDate) <= new Date(dateTo);
      });
    }
    // Sorting
    if (sortConfig.key && sortConfig.direction) {
      result.sort((a: any, b: any) => {
        let aValue = a[sortConfig.key!];
        let bValue = b[sortConfig.key!];
        // Handle special cases
        if (sortConfig.key === 'availability') {
          aValue = a.availability.current;
          bValue = b.availability.current;
        } else if (sortConfig.key === 'redemptions') {
          aValue = calculateRedeemed(a);
          bValue = calculateRedeemed(b);
        } else if (sortConfig.key === 'startDate' || sortConfig.key === 'endDate') {
          aValue = aValue ? new Date(aValue).getTime() : 0;
          bValue = bValue ? new Date(bValue).getTime() : 0;
        }
        if (aValue < bValue) {
          return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }
    setFilteredRewards(result);
  }, [statusFilter, searchTerm, dateFrom, dateTo, sortConfig]);
  const handleSort = (key: string) => {
    let direction: 'asc' | 'desc' | null = 'asc';
    if (sortConfig.key === key) {
      if (sortConfig.direction === 'asc') {
        direction = 'desc';
      } else if (sortConfig.direction === 'desc') {
        direction = null;
      }
    }
    setSortConfig({
      key: direction ? key : null,
      direction
    });
  };
  const handleCreateReward = () => {
    navigate('/rewards/new');
  };
  const handleExportCSV = () => {
    // Prepare data for CSV export
    const csvData = filteredRewards.map(reward => ({
      'Nome Premio': reward.name,
      Codice: reward.code,
      Stato: reward.status,
      Costo: reward.cost,
      Riscattati: calculateRedeemed(reward),
      Rimanenti: reward.availability.unlimited ? 'Illimitato' : reward.availability.current,
      Inizio: formatDateForCSV(reward.startDate),
      Fine: formatDateForCSV(reward.endDate)
    }));
    const headers = ['Nome Premio', 'Codice', 'Stato', 'Costo', 'Riscattati', 'Rimanenti', 'Inizio', 'Fine'];
    exportToCSV(csvData, 'GB_Partner.csv', headers);
    showToast('Esportazione CSV completata');
  };
  const handleRowClick = (rewardId: number) => {
    navigate(`/rewards/${rewardId}`);
  };
  const handleToggleStatus = (rewardId: number, currentStatus: string) => {
    const newStatus = currentStatus === 'Attivo' ? 'Inattivo' : currentStatus === 'Inattivo' ? 'Attivo' : currentStatus;
    setRewards(prev => prev.map(r => r.id === rewardId ? {
      ...r,
      status: newStatus
    } : r));
    showToast('Premio aggiornato');
    setOpenMenuId(null);
  };
  const handleDuplicate = (rewardId: number) => {
    showToast('Premio duplicato');
    setOpenMenuId(null);
  };
  const showToast = (message: string) => {
    setToast({
      message,
      show: true
    });
    setTimeout(() => {
      setToast({
        message: '',
        show: false
      });
    }, 3000);
  };
  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'Attivo':
        return <Play className="h-4 w-4 text-green-600" data-id="element-1786" />;
      case 'Programmato':
        return <Calendar className="h-4 w-4 text-blue-600" data-id="element-1787" />;
      case 'Inattivo':
        return <Pause className="h-4 w-4 text-amber-600" data-id="element-1788" />;
      case 'Scaduto':
        return <SkipBack className="h-4 w-4 text-gray-600" data-id="element-1789" />;
      default:
        return null;
    }
  };
  const getStatusLabel = (status: string) => {
    return status;
  };
  const formatDate = (dateString: string | null) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('it-IT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };
  const calculateRedeemed = (reward: any) => {
    if (reward.availability.unlimited) return reward.redemptionsTotal;
    return reward.availability.total - reward.availability.current;
  };
  const SortableHeader = ({
    label,
    sortKey,
    className = ''
  }: {
    label: string;
    sortKey: string;
    className?: string;
  }) => {
    const isSorted = sortConfig.key === sortKey;
    return <th className={`px-4 py-3 cursor-pointer select-none ${className}`} onClick={() => handleSort(sortKey)} data-id="element-1790">
        <div className="flex items-center justify-between whitespace-nowrap" data-id="element-1791">
          <span data-id="element-1792">{label}</span>
          <ArrowUpDown className={`h-3 w-3 ml-1 ${isSorted ? 'text-green-600' : 'text-gray-400'}`} data-id="element-1793" />
        </div>
      </th>;
  };
  const getTooltipPosition = (iconElement: HTMLElement) => {
    const rect = iconElement.getBoundingClientRect();
    const tooltipWidth = 256; // w-64 = 256px
    const tooltipHeight = 100; // approximate
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    let position: any = {
      bottom: '100%',
      marginBottom: '8px'
    };
    // Check if tooltip would overflow right
    if (rect.left + tooltipWidth / 2 > viewportWidth) {
      position.right = '0';
      position.left = 'auto';
    }
    // Check if tooltip would overflow left
    else if (rect.left - tooltipWidth / 2 < 0) {
      position.left = '0';
      position.right = 'auto';
    }
    // Center by default
    else {
      position.left = '50%';
      position.transform = 'translateX(-50%)';
    }
    // Check if tooltip would overflow top
    if (rect.top - tooltipHeight < 0) {
      position = {
        top: '100%',
        marginTop: '8px'
      };
      // Reapply horizontal positioning
      if (rect.left + tooltipWidth / 2 > viewportWidth) {
        position.right = '0';
        position.left = 'auto';
      } else if (rect.left - tooltipWidth / 2 < 0) {
        position.left = '0';
        position.right = 'auto';
      } else {
        position.left = '50%';
        position.transform = 'translateX(-50%)';
      }
    }
    return position;
  };
  return <div className="flex h-screen bg-gray-50" data-id="element-1794">
      <div className="w-20 flex-shrink-0" data-id="element-1795">
        <Sidebar data-id="element-1796" />
      </div>

      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-1797">
        <Topbar data-id="element-1798" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6" data-id="element-1799">
          <div className="flex items-center justify-between mb-6" data-id="element-1800">
            <div data-id="element-1801">
              <h1 className="text-2xl font-bold text-gray-900" data-id="element-1802">Premi</h1>
              <p className="text-sm text-gray-500 mt-1" data-id="element-1803">
                Crea e gestisci le offerte disponibili per gli utenti.
              </p>
            </div>
            <div className="flex items-center gap-3" data-id="element-1804">
              <div style={{
              background: 'linear-gradient(90deg, rgba(255, 0, 77, 1) 0%, rgba(116, 10, 214, 1) 50%, rgba(116, 10, 214, 1) 100%)',
              padding: '1px',
              borderRadius: '100px'
            }} data-id="element-1805">
                <button onClick={() => setIsAISidebarOpen(true)} className="text-black transition-colors flex items-center gap-1.5 bg-white px-4 py-2 hover:bg-gray-50" style={{
                borderRadius: '100px'
              }} title="AI Insights" data-id="element-1806">
                  <span className="text-sm" data-id="element-1807">Suggerimenti AI</span>
                </button>
              </div>
              <button onClick={handleExportCSV} className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 transition-colors" style={{
              borderRadius: '100px'
            }} data-id="element-1808">
                <Download className="h-4 w-4 mr-2" data-id="element-1809" />
                Esporta CSV
              </button>
              <button onClick={handleCreateReward} className="inline-flex items-center px-4 py-2 bg-greenback text-white text-sm font-medium hover:bg-greenback-600 transition-colors" style={{
              borderRadius: '100px'
            }} data-id="element-1810">
                <Plus className="h-4 w-4 mr-2" data-id="element-1811" />
                Crea Premio
              </button>
            </div>
          </div>

          {/* Filters */}
          <div className="mb-6 flex flex-wrap gap-3" data-id="element-1812">
            <div className="relative" data-id="element-1813">
              <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" data-id="element-1814" />
              <input type="text" placeholder="Cerca premio..." className="rounded-lg border border-gray-300 pl-10 pr-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-greenback" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-1815" />
            </div>

            {/* Date From */}
            <div className="flex items-center rounded-lg border border-gray-300 px-3 py-2 gap-2" data-id="element-1816">
              <Calendar className="h-4 w-4 text-gray-500" data-id="element-1817" />
              <span className="text-sm text-gray-600" data-id="element-1818">Da:</span>
              <input type="date" className="bg-transparent text-sm focus:outline-none" value={dateFrom} onChange={e => setDateFrom(e.target.value)} data-id="element-1819" />
            </div>

            {/* Date To */}
            <div className="flex items-center rounded-lg border border-gray-300 px-3 py-2 gap-2" data-id="element-1820">
              <Calendar className="h-4 w-4 text-gray-500" data-id="element-1821" />
              <span className="text-sm text-gray-600" data-id="element-1822">A:</span>
              <input type="date" className="bg-transparent text-sm focus:outline-none" value={dateTo} onChange={e => setDateTo(e.target.value)} data-id="element-1823" />
            </div>

            <div className="flex items-center rounded-lg border border-gray-300 px-3 py-2" data-id="element-1824">
              <Filter className="mr-2 h-4 w-4 text-gray-500" data-id="element-1825" />
              <select className="bg-transparent text-sm focus:outline-none pr-8" value={statusFilter} onChange={e => setStatusFilter(e.target.value)} style={{
              backgroundImage: 'none'
            }} data-id="element-1826">
                <option value="Tutti" data-id="element-1827">Tutti gli stati</option>
                <option value="Attivo" data-id="element-1828">▶️ Attivo</option>
                <option value="Programmato" data-id="element-1829">🗓 Programmato</option>
                <option value="Inattivo" data-id="element-1830">⏸️ Inattivo</option>
                <option value="Scaduto" data-id="element-1831">⏮️ Scaduto</option>
              </select>
            </div>
          </div>

          {/* Table or Empty State */}
          {filteredRewards.length > 0 ? <div className="rounded-lg border border-gray-200 bg-white overflow-hidden" data-id="element-1832">
              <div className="overflow-x-auto" data-id="element-1833">
                <table className="w-full" data-id="element-1834">
                  <thead data-id="element-1835">
                    <tr className="bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1836">
                      <th className="px-4 py-3" data-id="element-1837">Immagine</th>
                      <SortableHeader label="Nome Premio" sortKey="name" className="min-w-[160px]" data-id="element-1838" />
                      <SortableHeader label="Codice" sortKey="code" data-id="element-1839" />
                      <SortableHeader label="Stato" sortKey="status" data-id="element-1840" />
                      <SortableHeader label="Costo" sortKey="cost" data-id="element-1841" />
                      <SortableHeader label="Riscattati" sortKey="redemptions" data-id="element-1842" />
                      <SortableHeader label="Rimanenti" sortKey="availability" data-id="element-1843" />
                      <SortableHeader label="Inizio" sortKey="startDate" data-id="element-1844" />
                      <SortableHeader label="Fine" sortKey="endDate" data-id="element-1845" />
                      <th className="px-4 py-3 whitespace-nowrap" data-id="element-1846">AI Tips</th>
                      <th className="px-4 py-3" data-id="element-1847">Azioni</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200" data-id="element-1848">
                    {filteredRewards.map(reward => <tr key={reward.id} className="hover:bg-gray-50 cursor-pointer" onClick={() => handleRowClick(reward.id)} data-id="element-1849">
                        <td className="px-4 py-4" data-id="element-1850">
                          <img src={reward.image} alt={reward.name} className="h-16 w-16 rounded-lg object-cover" data-id="element-1851" />
                        </td>
                        <td className="px-4 py-4" style={{
                    minWidth: '160px'
                  }} data-id="element-1852">
                          <div className="font-medium text-gray-900" data-id="element-1853">
                            {reward.name}
                          </div>
                        </td>
                        <td className="px-4 py-4" data-id="element-1854">
                          <span className="font-mono text-sm text-gray-700" data-id="element-1855">
                            {reward.code}
                          </span>
                        </td>
                        <td className="px-4 py-4" data-id="element-1856">
                          <div className="inline-flex items-center justify-center w-8 h-8 rounded-full hover:bg-gray-100 cursor-help group" title={getStatusLabel(reward.status)} data-id="element-1857">
                            {getStatusIcon(reward.status)}
                          </div>
                        </td>
                        <td className="px-4 py-4 font-medium" data-id="element-1858">
                          <div className="flex items-center gap-1" data-id="element-1859">
                            <Gem className="h-3.5 w-3.5 text-gray-500" data-id="element-1860" />
                            <span data-id="element-1861">{reward.cost}</span>
                          </div>
                        </td>
                        <td className="px-4 py-4 font-medium" data-id="element-1862">
                          {calculateRedeemed(reward)}
                        </td>
                        <td className="px-4 py-4" data-id="element-1863">
                          {reward.availability.unlimited ? <span className="text-gray-600" data-id="element-1864">∞</span> : <span className="font-medium" data-id="element-1865">
                              {reward.availability.current}
                            </span>}
                        </td>
                        <td className="px-4 py-4 text-sm text-gray-600" data-id="element-1866">
                          {formatDate(reward.startDate)}
                        </td>
                        <td className="px-4 py-4 text-sm text-gray-600" data-id="element-1867">
                          {formatDate(reward.endDate)}
                        </td>
                        <td className="px-4 py-4" data-id="element-1868">
                          {reward.aiHint ? <div className="relative inline-block" onMouseEnter={() => setHoveredAITip(reward.id)} onMouseLeave={() => setHoveredAITip(null)} onClick={e => e.stopPropagation()} data-id="element-1869">
                              <div style={{
                        background: 'linear-gradient(90deg, rgba(255, 0, 77, 1) 0%, rgba(116, 10, 214, 1) 100%)',
                        padding: '1px',
                        borderRadius: '50%',
                        width: '32px',
                        height: '32px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer'
                      }} data-id="element-1870">
                                <div style={{
                          background: 'white',
                          borderRadius: '50%',
                          width: '100%',
                          height: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }} data-id="element-1871">
                                  <MessageCircle className="h-4 w-4 text-purple-600" data-id="element-1872" />
                                </div>
                              </div>

                              {hoveredAITip === reward.id && <div ref={tooltipRef} className="absolute z-50 w-64" style={{
                        bottom: '100%',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        marginBottom: '8px'
                      }} data-id="element-1873">
                                  <div style={{
                          background: 'linear-gradient(90deg, rgba(255, 0, 77, 1) 0%, rgba(116, 10, 214, 1) 100%)',
                          padding: '1px',
                          borderRadius: '8px'
                        }} data-id="element-1874">
                                    <div className="p-3 bg-white rounded-lg shadow-xl" data-id="element-1875">
                                      <div className="text-xs font-semibold text-gray-900 mb-1" data-id="element-1876">
                                        {reward.aiHint.text}
                                      </div>
                                      <div className="text-xs text-gray-600" data-id="element-1877">
                                        {reward.aiHint.explanation}
                                      </div>
                                    </div>
                                  </div>
                                  <div style={{
                          position: 'absolute',
                          bottom: '-5px',
                          left: '50%',
                          marginLeft: '-4px',
                          width: '8px',
                          height: '8px',
                          background: 'linear-gradient(135deg, rgba(255, 0, 77, 1) 0%, rgba(116, 10, 214, 1) 100%)',
                          transform: 'rotate(45deg)'
                        }} data-id="element-1878" />
                                </div>}
                            </div> : <span className="text-xs text-gray-400" data-id="element-1879">-</span>}
                        </td>
                        <td className="px-4 py-4" data-id="element-1880">
                          <div className="relative" data-id="element-1881">
                            <button onClick={e => {
                        e.stopPropagation();
                        setOpenMenuId(openMenuId === reward.id ? null : reward.id);
                      }} className="p-1 hover:bg-gray-100 rounded" data-id="element-1882">
                              <MoreVertical className="h-5 w-5 text-gray-500" data-id="element-1883" />
                            </button>

                            {openMenuId === reward.id && <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 z-10" data-id="element-1884">
                                <button onClick={e => {
                          e.stopPropagation();
                          handleRowClick(reward.id);
                        }} className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 flex items-center" data-id="element-1885">
                                  <Edit className="h-4 w-4 mr-2" data-id="element-1886" />
                                  Modifica
                                </button>
                                <button onClick={e => {
                          e.stopPropagation();
                          handleToggleStatus(reward.id, reward.status);
                        }} className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 flex items-center" disabled={reward.status === 'Scaduto' || reward.status === 'Programmato'} data-id="element-1887">
                                  {reward.status === 'Attivo' ? <>
                                      <Pause className="h-4 w-4 mr-2" data-id="element-1888" />
                                      Disattiva
                                    </> : <>
                                      <Play className="h-4 w-4 mr-2" data-id="element-1889" />
                                      Attiva
                                    </>}
                                </button>
                                <button onClick={e => {
                          e.stopPropagation();
                          handleDuplicate(reward.id);
                        }} className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 flex items-center border-t border-gray-100" data-id="element-1890">
                                  <Copy className="h-4 w-4 mr-2" data-id="element-1891" />
                                  Duplica
                                </button>
                              </div>}
                          </div>
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>
            </div> : <div className="rounded-lg border border-gray-200 bg-white p-12" data-id="element-1892">
              <div className="text-center" data-id="element-1893">
                <Gift className="h-16 w-16 text-gray-300 mx-auto mb-4" data-id="element-1894" />
                <h2 className="text-xl font-semibold text-gray-700 mb-2" data-id="element-1895">
                  Nessun premio ancora
                </h2>
                <p className="text-gray-500 max-w-md mx-auto mb-6" data-id="element-1896">
                  Crea il tuo primo premio per permettere agli utenti di
                  riscattare con i punti.
                </p>
                <button onClick={handleCreateReward} className="inline-flex items-center px-4 py-2 bg-greenback text-white rounded-lg hover:bg-greenback-600 transition-colors" data-id="element-1897">
                  <Plus className="h-4 w-4 mr-2" data-id="element-1898" />
                  Crea Premio
                </button>
              </div>
            </div>}
        </main>
      </div>

      {/* AI Sidebar */}
      <AISidebar isOpen={isAISidebarOpen} onClose={() => setIsAISidebarOpen(false)} title="Suggerimenti AI per i tuoi premi" data-id="element-1899">
        <AIRecommendationPanel recommendations={[{
        id: '1',
        title: 'Set Attivi Puri (Fitoretinolo + Collagene)',
        type: 'Prodotto Viso',
        diamondRange: '60-70 punti',
        reason: 'Trend in crescita: prodotti anti-age naturali +22%. Alta domanda per attivi concentrati e personalizzabili.',
        ctaLabel: 'Crea premio da qui',
        onCtaClick: () => navigate('/rewards/new')
      }, {
        id: '2',
        title: 'Ottimizza "Kit Cosmetici Solidi"',
        type: 'Ottimizzazione',
        diamondRange: '45 punti (da 50)',
        reason: 'Disponibilità bassa (12/50) e trend +25%. Riduci costo di 5 punti per aumentare accessibilità e velocizzare rotazione stock.',
        ctaLabel: 'Duplica e modifica',
        onCtaClick: () => {
          showToast('Premio duplicato con modifiche suggerite');
          setTimeout(() => navigate('/rewards/new'), 1000);
        }
      }]} data-id="element-1900" />
      </AISidebar>

      {/* Toast Notification */}
      {toast.show && <div className="fixed bottom-6 right-6 bg-gray-900 text-white px-6 py-3 rounded-lg shadow-lg z-50 animate-fade-in" data-id="element-1901">
          {toast.message}
        </div>}
    </div>;
};
export default Rewards;